module.exports = __webpack_public_path__ + "assets/img/f1dcd3dba65a03f47e08032887f9f6f7.svg";